import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { EpisodeSkeleton } from 'common/ui/skeleton-ui';
import _ from 'lodash';

import { EpisodeCard } from './components';
import { ShowMore } from 'modules2/components';
import { fmtHSS } from 'common/ui/utils';

import container from './PodCastEpisodeCard.container';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    background: theme.palette.paperColor,
    color: theme.palette.textColor
  },
  container: {
    padding: theme.spacing(2),
    fontFamily: 'Arial'
    // textAlign: 'center',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    padding: '10px 20px'
  },
  episodeContainer: {
    marginBottom: 10
  },
  empty: {
    fontFamily: theme.typography.fontFamily,
    padding: '5px 20px'
  }
}));

const PodCastEpisodeCard = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));

  const {
    audioPlayer,
    podcastState: { currentPodcast, nextEpisode, isNextEpisode },
    podcastPlaylistState: {
      playlists,
      episodes,
      currentlyViewedPlaylist,
      loading
    },
    onRequestNextPodcastEpisode,
    // onFetchPodCastListStart,
    onSetPlayerPlaylist,
    onFetchPodCastEpisodeStart,
    onEpisodePlayerStart
  } = props;

  const nextItem = () => {
    onRequestNextPodcastEpisode(currentPodcast, nextEpisode);
  };

  const podcastEpisode = playlists[currentlyViewedPlaylist] ?? [];

  useEffect(() => {
    if (!_.isNil(currentlyViewedPlaylist) && _.isEmpty(podcastEpisode)) {
      onFetchPodCastEpisodeStart(currentlyViewedPlaylist);
    }
  }, [podcastEpisode]);

  useEffect(() => {
    if (podcastEpisode && Object.keys(podcastEpisode).length > 0) {
      setTimeout(() => {
        const params = new URLSearchParams(window.location.search);
        const podcastURL = params.get('podcastid');
        const episodeURL = params.get('episodeid');
        if (podcastURL && episodeURL) {
          onEpisodePlayerStart(podcastURL, episodeURL);
        }
      }, 100);
    }
  }, [podcastEpisode]);


  const episodeList = (loading) => {
    if (loading) {
      return [...Array(matchesXS ? 4 : 6)].map((_, idx) => {
        return <EpisodeSkeleton key={idx} />;
      });
    }

    return podcastEpisode.length ? (
      podcastEpisode
        .map((id) => episodes[id])
        .filter((x) => x)
        .map((episode, id) => {
          return (
            <EpisodeCard
              audioPlayer={audioPlayer}
              key={id}
              podcastid={currentPodcast}
              episodeid={
                episode.id
                  ? episode.id
                  : `${episode.podcastId}_${episode.guid.split(' ')[0]}`
              }
              title={
                episode.current_track ? episode.current_track : episode.title
              }
              description={episode.text ? episode.text : episode.description}
              length={
                episode.audio_length_sec
                  ? fmtHSS(episode.audio_length_sec)
                  : episode.duration
                  ? episode.duration
                  : fmtHSS(0)
              }
              pub_date={
                episode.datePublished
                  ? episode.datePublished * 1000
                  : episode.createdAt
                  ? episode.createdAt.toString().split('T')[0]
                  : episode.pub_date_ms
                  ? episode.pub_date_ms
                  : episode.releaseDate
              }
            />
          );
        })
    ) : (
      <div className={classes.empty}>Episodes not available.</div>
    );
  };

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0 }}>
        <div className={classes.container}>
          <Typography className={classes.title}>{'Episodes'}</Typography>
          <div className={classes.episodeContainer}>{episodeList(loading)}</div>
          {/*{!loading && isNextEpisode && <ShowMore nextRadioList={nextItem}/>}*/}
        </div>
      </CardContent>
    </Card>
  );
};

export default container(PodCastEpisodeCard);
